import { ConvertableFromApi } from './ConvertableFromApi';

export class VreConfiguration extends ConvertableFromApi<VreConfiguration> {
    maintenance!: MaintenanceConfiguration;
    synctime!: number;
    workspaceRefreshInterval: number;
    vmUpdateStateHoldInterval: number;
    surfToeslag: number;

    constructor(data?: any) {
        super(data);

        if(!this.objectFromApi){
            return;
        }
        this.maintenance = new MaintenanceConfiguration();
        this.maintenance.message = this.objectFromApi.maintenance.message;
        this.maintenance.start = this.objectFromApi.maintenance.start;
        this.maintenance.end = this.objectFromApi.maintenance.end;
        if (this.objectFromApi.synctime) {
            this.synctime = this.objectFromApi.synctime * 1000;
        }
        this.workspaceRefreshInterval = this.objectFromApi.workspaceRefreshInterval
          ? this.objectFromApi.workspaceRefreshInterval * 1000
          : 40000;
        this.surfToeslag = this.objectFromApi.surfToeslag
        // hold visual VM state for 3 refresh cycles
        this.vmUpdateStateHoldInterval = this.workspaceRefreshInterval * 3;
    }

    createNew(element: any): VreConfiguration {
        return new VreConfiguration(element);
    }
}

export class MaintenanceConfiguration {
    message!: string;
    start!: Date;
    end!: Date;
}